/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Share_Manage_Team_ButtonInputs */

const en_team_share_manage_team_button = /** @type {(inputs: Team_Share_Manage_Team_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage Team`)
};

const fr_team_share_manage_team_button = /** @type {(inputs: Team_Share_Manage_Team_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gérer l’équipe`)
};

const de_team_share_manage_team_button = /** @type {(inputs: Team_Share_Manage_Team_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team leiten`)
};

const it_team_share_manage_team_button = /** @type {(inputs: Team_Share_Manage_Team_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestire il team`)
};

const ru_team_share_manage_team_button = /** @type {(inputs: Team_Share_Manage_Team_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Управление командой`)
};

const es_team_share_manage_team_button = /** @type {(inputs: Team_Share_Manage_Team_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestionar equipo`)
};

const zh_cn2_team_share_manage_team_button = /** @type {(inputs: Team_Share_Manage_Team_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`管理团队`)
};

const ja_team_share_manage_team_button = /** @type {(inputs: Team_Share_Manage_Team_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`チーム管理`)
};

const hi_team_share_manage_team_button = /** @type {(inputs: Team_Share_Manage_Team_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टीम का प्रबंधन करें`)
};

const pt_pt2_team_share_manage_team_button = /** @type {(inputs: Team_Share_Manage_Team_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerenciar equipe`)
};

/**
* | output |
* | --- |
* | "Manage Team" |
*
* @param {Team_Share_Manage_Team_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_manage_team_button = /** @type {((inputs?: Team_Share_Manage_Team_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_Manage_Team_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_share_manage_team_button(inputs)
	if (locale === "de") return de_team_share_manage_team_button(inputs)
	if (locale === "it") return it_team_share_manage_team_button(inputs)
	if (locale === "ru") return ru_team_share_manage_team_button(inputs)
	if (locale === "es") return es_team_share_manage_team_button(inputs)
	if (locale === "zh-CN") return zh_cn2_team_share_manage_team_button(inputs)
	if (locale === "ja") return ja_team_share_manage_team_button(inputs)
	if (locale === "hi") return hi_team_share_manage_team_button(inputs)
	if (locale === "pt-PT") return pt_pt2_team_share_manage_team_button(inputs)
	return en_team_share_manage_team_button(inputs)
});